var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ show: _vm.show},attrs:{"id":"modal-cover"}})
}
var staticRenderFns = []

export { render, staticRenderFns }